<template>
  <div v-if="isValidURL(message.payload.message)">
    <div
      v-if="sender === 'customer'"
      class="balloon balloon-text cursor-pointer"
      @click.exact="bubblePopup"
      @click.shift.left.exact="bubbleShift"
    >
      <a :href="message.payload.message" target="_blank">
        {{ findTitle(message.payload) }}
      </a>
    </div>
    <div
      v-else
      class="balloon balloon-text"
      @click.shift.left.exact="bubbleShift"
    >
      <a :href="message.payload.message" target="_blank">
        {{ findTitle(message.payload) }}
      </a>
    </div>
  </div>
  <div v-else>
    <div
      v-if="sender === 'customer'"
      class="balloon balloon-text cursor-pointer"
      @click.exact="bubblePopup"
      @click.shift.left.exact="bubbleShift"
    >
      {{ findTitle(message.payload) }}
    </div>
    <div
      v-else
      class="balloon balloon-text"
      @click.shift.left.exact="bubbleShift"
    >
      {{ findTitle(message.payload) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayloadPostback',
  props: {
    sessionId: String,
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    findTitle(payload) {
      const obj = typeof payload === 'string' ? JSON.parse(string) : payload
      return obj.title ? obj.title : obj.message
    },
    isValidURL(string) {
      try {
        new URL(string)
      } catch (_) {
        return false
      }

      return true
    },
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    },
    bubblePopup() {
      this.$emit('learnPopup', {
        word: this.findTitle(this.message.payload),
        query: {
          session_id: this.sessionId,
          bot_conversation_id: this.conversation.conversation_id,
          sender: this.sender
        }
      })
    }
  }
}
</script>
